/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Plan_Monthly_Equivalent_ShortInputs */

const en_plan_monthly_equivalent_short = /** @type {(inputs: Plan_Monthly_Equivalent_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/month`)
};

const es_plan_monthly_equivalent_short = /** @type {(inputs: Plan_Monthly_Equivalent_ShortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}/mes`)
};

/**
* | output |
* | --- |
* | "{price}/month" |
*
* @param {Plan_Monthly_Equivalent_ShortInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_monthly_equivalent_short = /** @type {((inputs: Plan_Monthly_Equivalent_ShortInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Monthly_Equivalent_ShortInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_monthly_equivalent_short(inputs)
	return en_plan_monthly_equivalent_short(inputs)
});